import {appNotificationsInterceptor} from './app_notifications_interceptor.js';
import {MODULE_DISTRIBUTION_SERVICES} from '../services/app.services.module.js';
export const MODULE_DISTRIBUTION_DAO = 'app.dao';
angular.module(MODULE_DISTRIBUTION_DAO, ['ngResource', MODULE_DISTRIBUTION_SERVICES])
       .factory('appNotificationsInterceptor', appNotificationsInterceptor);



// WEBPACK FOOTER //
// ./modules/distribution/data/app_dao_module.js